import React, { useState } from 'react';
import Modal from 'react-bootstrap/Modal'
import Pages from '.'
import { elakayAutoText } from "../../pageInside/dataElakay";
import {
    FaPlay, FaSave, FaTrashAlt, FaDesktop, FaCode,
    FaFileCode, FaExclamationTriangle, FaEye, FaEyeSlash
} from "react-icons/fa";
import './codeEdit.css';


let __elakayInfoSource;
const __setElakayInfoSource = (infoSource) => { if (infoSource) __elakayInfoSource = infoSource; };
const __elakayText = (key, fallback) =>
  __elakayInfoSource?.laguangeElakay?.("frontElakayHardcodedText", __elakayInfoSource.languageAPI)?.["codeEdit"]?.[key] || fallback;

function CodeEdit(props) {
    const {
        infoSource,
        editAdd, 
        setEditAdd,
        nameObj,
        edit_add,
        token,
        AlllanguageSelect,
        languageUsertra,
        languageTradictor,
        updateLanguageElakay0,
        deleteLanguageElakay0
    } = props
    __setElakayInfoSource(infoSource);

    const [showEmailPage, setShowEmailPage] = useState(false);


    const emailTemplates = [
      {
        title: __elakayText("t001", "send e-mail confirmation"),
        data: {
          user: { firstname: "John", lastname: "Doe" },
          subject: "Welcome to Elakay - Account Activation",
          random: 123456,
          url: "https://www.example.com",
          urlLogo: "http://localhost:2284/elakay_api/icon/logo_elakay/logoelakay.ico",
          texts: {
            welcomeTitle: "Welcome to Elakay",
            introduction: `to the Elakay community! We’re thrilled to have you join us.`,
            instructions: `To activate your account and gain full access to all our services, please use the verification code below:`,
            verificationCodeLabel: `Verification Code: `,
            expiryNotice: `⚠️ This code is valid for 20 minutes. Make sure to use it within this time; otherwise, it will expire, and you will need to request a new one to complete your activation.`,
            accountRemovalWarning: `Important Note: If you do not activate your account within 7 days, it will be automatically removed from our database.`,
            encouragement: `By activating your account, you are joining a dynamic network of professionals, artisans, and entrepreneurs committed to success. Discover personalized tools, growth opportunities, and the support of a community with shared values.`,
            supportNote: `If you have any questions or need assistance with activating your account, our team is here to help.`,
            signature: `See you soon, The Elakay Team`
          }
        },
        htmlTemplate: `
          <div style="background:#f4f6f8; padding:32px 16px; font-family:Arial,Helvetica,sans-serif;">
          <style>
            @media only screen and (max-width:600px) {
              .elakay-card { border-radius:0 !important; }
              .elakay-body { padding:28px 22px !important; }
            }
          </style>
          <div class="elakay-card" style="max-width:600px; width:100%; margin:0 auto; background:#ffffff; border-radius:14px; overflow:hidden; box-shadow:0 6px 24px rgba(0,59,79,0.12);">
            <div style="background:linear-gradient(135deg,#004b63 0%,#007399 60%,#00a4d8 100%); padding:32px 24px; text-align:center;">
              <img src="\${urlLogo}" alt="${infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).languageCodeEdit.t001}" style="width: 42px; height: 42px; vertical-align: middle; filter: brightness(0) invert(1); margin-right: 10px;">
              <span style="font-size: 26px; font-weight: bold; vertical-align: middle; color:#ffffff; letter-spacing:0.5px;">Elakay</span>
            </div>
            <div class="elakay-body" style="padding: 36px 40px; color:#374151;">
              <h2 style="font-size: 22px; color: #0f2d3d; margin: 0 0 6px; font-weight:700;">\${texts.welcomeTitle}</h2>
              <p style="font-size: 15px; color:#6b7280; margin: 0 0 24px;">\${user.firstname} \${user.lastname}</p>
              <p style="font-size: 15px; line-height: 1.7; margin-bottom: 14px;">\${texts.introduction}</p>
              <p style="font-size: 15px; line-height: 1.7; margin-bottom: 24px;">\${texts.instructions}</p>

              <div style="background:#f0f8fb; border:1px solid #b3dde8; border-radius: 12px; padding: 20px; margin: 0 0 24px; text-align: center;">
                <span style="display:block; font-size:11px; font-weight:700; color:#007399; text-transform:uppercase; letter-spacing:0.12em; margin-bottom:8px;">\${texts.verificationCodeLabel}</span>
                <span style="font-size:30px; font-weight:700; color:#004b63; letter-spacing:6px;">\${random}</span>
              </div>

              <p style="font-size: 13px; color: #c0392b; background:#fff5f5; border-left:3px solid #c0392b; padding:10px 14px; border-radius:0 8px 8px 0; margin-bottom: 28px;">\${texts.expiryNotice}</p>

              <div style="text-align:center; margin: 0 0 28px;">
                <a href="\${url}" style="display: inline-block; text-decoration: none; background-color: #007399; color: white; padding: 14px 36px; font-size: 15px; font-weight: bold; border-radius: 9px;">
                  Activate My Account
                </a>
              </div>

              <p style="font-size: 13px; line-height: 1.6; color:#6b7280; margin-bottom: 14px;">\${texts.accountRemovalWarning}</p>
              <p style="font-size: 13px; line-height: 1.6; color:#6b7280; margin-bottom: 28px;">\${texts.supportNote}</p>

              <hr style="border:none; border-top:1px solid #eef1f4; margin:0 0 20px;">
              <p style="font-size: 13px; line-height: 1.6; color: #9aa3ad; margin:0;">\${texts.signature}</p>
            </div>
            <div style="background:#f8fafc; padding:16px 24px; text-align:center; border-top:1px solid #eef1f4;">
              <p style="font-size:11px; color:#9aa3ad; margin:0;">© Elakay · elakay.com</p>
            </div>
          </div>
          </div>
        `
      }
      , 
      {
        title: __elakayText("t002", "send e-mail verificatiom"),
        data: {
        title: __elakayText("t002", "send e-mail verificatiom"),
        user: { firstname: "John", lastname: "Doe" },
        subject: "Elakay Security Alert - New Device Login Verification",
        random: 123456,
        url: "https://www.example.com",
        urlTrust  : "https://www.example.com/trustDevice",
        urlLogo: "http://localhost:2284/elakay_api/icon/logo_elakay/logoelakay.ico",
        texts: {
          welcomeTitle: "New Device Login Verification",
          introduction: `we detected a login attempt to your Elakay account from a new device.`,
          instructions: `To complete this connection, please enter the verification code below on your computer:`,
          verificationCodeLabel: `Verification Code: `,
          expiryNotice: `⚠️ This code will expire in 20 minutes.`,
          encouragement: `If this login attempt was not made by you, please secure your account immediately by changing your password. Our support team is available if you have any questions or need assistance.`,
          signature: `Thank you for choosing Elakay, The Elakay Security Team`
        }
      },
   htmlTemplate: `
<div style="background:#f4f6f8;padding:32px 16px;font-family:Arial,Helvetica,sans-serif;">
<style>
  @media only screen and (max-width:600px) {
    .elakay-card2 { border-radius:0 !important; }
    .elakay-body2 { padding:32px 22px !important; }
    .elakay-btn-row a { display:block !important; width:100% !important; margin:0 0 10px !important; box-sizing:border-box !important; }
  }
</style>
<div class="elakay-card2" style="max-width:580px;width:100%;margin:0 auto;font-family:Arial,sans-serif;border-radius:16px;overflow:hidden;border:1px solid #e0e0e0;background:#ffffff;box-shadow:0 6px 24px rgba(0,59,79,0.12);">

  <div style="background:linear-gradient(135deg,#004b63 0%,#007399 60%,#00a4d8 100%);padding:28px 24px;text-align:center;">
    <div style="display:inline-block;">
      <img src="\${urlLogo}" alt="${infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).languageCodeEdit.t002}" style="width:36px;height:36px;vertical-align:middle;filter:brightness(0) invert(1);margin-right:10px;">
      <span style="font-size:24px;font-weight:700;color:white;vertical-align:middle;letter-spacing:0.5px;">Elakay</span>
    </div>
  </div>

  <div class="elakay-body2" style="padding:36px 32px;text-align:center;">

    <h2 style="font-size:22px;font-weight:700;color:#0f2d3d;margin:0 0 8px;">\${texts.welcomeTitle}</h2>
    <p style="font-size:17px;font-weight:600;color:#0d2d3d;margin:0 0 20px;">Hello \${user.firstname} \${user.lastname},</p>
    <p style="font-size:15px;line-height:1.7;color:#555;margin:0 0 12px;">\${texts.introduction}</p>
    <p style="font-size:15px;line-height:1.7;color:#555;margin:0 0 28px;">\${texts.instructions}</p>

    <div style="background:#f0f8fb;border:1.5px solid #b3dde8;border-radius:12px;padding:20px 24px;margin:0 0 16px;text-align:center;">
      <span style="font-size:11px;font-weight:600;color:#007399;text-transform:uppercase;letter-spacing:0.1em;display:block;margin-bottom:10px;">${infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).languageCodeEdit.t003}</span>
      <span style="font-size:32px;font-weight:700;color:#004b63;letter-spacing:8px;">\${random}</span>
    </div>

    <p style="font-size:13px;color:#c0392b;background:#fff5f5;border-left:3px solid #c0392b;padding:10px 14px;border-radius:0 8px 8px 0;margin:0 0 28px;">\${texts.expiryNotice}</p>

  <div class="elakay-btn-row" style="margin:0 0 28px;">
  <a href="$\{url}" style="display:inline-block;text-decoration:none;background:#007399;color:white;padding:13px 28px;font-size:14px;font-weight:700;border-radius:9px;text-align:center;box-sizing:border-box;margin-right:12px;">${infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).languageCodeEdit.t004}</a>
  <a href="$\{urlTrust}" style="display:inline-block;text-decoration:none;background:transparent;color:#007399;padding:12px 28px;font-size:14px;font-weight:700;border-radius:9px;text-align:center;border:1.5px solid #007399;box-sizing:border-box;">${infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).languageCodeEdit.t005}</a>
</div>

    <div style="background:#fff8f8;border-left:3px solid #c0392b;border-radius:0 9px 9px 0;padding:13px 16px;margin:0 0 24px;text-align:left;">
      <p style="font-size:13px;color:#555;margin:0;line-height:1.6;">\${texts.encouragement}</p>
    </div>

    <hr style="border:none;border-top:1px solid #e0e0e0;margin:0 0 20px;">
    <p style="font-size:13px;color:#888;margin:0;line-height:1.6;">\${texts.signature}</p>

  </div>

  <div style="background:#f0f8fb;border-top:1px solid #b3dde8;padding:16px 24px;text-align:center;">
    <p style="font-size:12px;color:#007399;margin:0;opacity:0.75;">${infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).languageCodeEdit.t006}</p>
  </div>

</div>
</div>
`
    },
      
      {
        title: __elakayText("t003", "resend Code Verification"),
        data: {
          user: { firstname: "John", lastname: "Doe" },
          subject: "Elakay - Resend Verification Code",
          random: 123456,
          url: "https://www.example.com",
          urlLogo: "http://localhost:2284/elakay_api/icon/logo_elakay/logoelakay.ico",
          texts: {
            welcomeTitle: "Resend Verification Code",
            introduction: `here is your new verification code to complete the login on your new device.`,
            instructions: `To finalize your connection, please enter the verification code below on your computer:`,
            verificationCodeLabel: `New Verification Code:`,
            expiryNotice: `⚠️ This code will expire in 20 minutes.`,
            encouragement: `If this login attempt wasn’t made by you, please secure your account by changing your password. Our support team is here if you need further assistance.`,
            signature: `Best regards, The Elakay Security Team`
          }
        },
        htmlTemplate: `
          <div style="background:#f4f6f8; padding:32px 16px; font-family:Arial,Helvetica,sans-serif;">
          <style>
            @media only screen and (max-width:600px) {
              .elakay-card3 { border-radius:0 !important; }
              .elakay-body3 { padding:28px 22px !important; }
            }
          </style>
          <div class="elakay-card3" style="max-width:600px; width:100%; margin:0 auto; background:#ffffff; border-radius:14px; overflow:hidden; box-shadow:0 6px 24px rgba(0,59,79,0.12);">
            <div style="background:linear-gradient(135deg,#004b63 0%,#007399 60%,#00a4d8 100%); padding:32px 24px; text-align:center;">
              <img src="\${urlLogo}" alt="${infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).languageCodeEdit.t007}" style="width: 42px; height: 42px; vertical-align: middle; filter: brightness(0) invert(1); margin-right: 10px;">
              <span style="font-size: 26px; font-weight: bold; vertical-align: middle; color:#ffffff; letter-spacing:0.5px;">Elakay</span>
            </div>
            <div class="elakay-body3" style="padding: 36px 40px; color:#374151;">
              <h2 style="font-size: 22px; color: #0f2d3d; margin: 0 0 6px; font-weight:700;">\${texts.welcomeTitle}</h2>
              <p style="font-size: 15px; color:#6b7280; margin: 0 0 24px;">\${user.firstname} \${user.lastname}</p>
              <p style="font-size: 15px; line-height: 1.7; margin-bottom: 14px;">\${texts.introduction}</p>
              <p style="font-size: 15px; line-height: 1.7; margin-bottom: 24px;">\${texts.instructions}</p>

              <div style="background:#f0f8fb; border:1px solid #b3dde8; border-radius: 12px; padding: 20px; margin: 0 0 24px; text-align: center;">
                <span style="display:block; font-size:11px; font-weight:700; color:#007399; text-transform:uppercase; letter-spacing:0.12em; margin-bottom:8px;">\${texts.verificationCodeLabel}</span>
                <span style="font-size:30px; font-weight:700; color:#004b63; letter-spacing:6px;">\${random}</span>
              </div>

              <p style="font-size: 13px; color: #c0392b; background:#fff5f5; border-left:3px solid #c0392b; padding:10px 14px; border-radius:0 8px 8px 0; margin-bottom: 28px;">\${texts.expiryNotice}</p>

              <div style="text-align:center; margin: 0 0 28px;">
                <a href="\${url}" style="display: inline-block; text-decoration: none; background-color: #007399; color: white; padding: 14px 36px; font-size: 15px; font-weight: bold; border-radius: 9px;">
                  Verify My Device
                </a>
              </div>

              <p style="font-size: 13px; line-height: 1.6; color:#6b7280; margin-bottom: 28px;">\${texts.encouragement}</p>

              <hr style="border:none; border-top:1px solid #eef1f4; margin:0 0 20px;">
              <p style="font-size: 13px; line-height: 1.6; color: #9aa3ad; margin:0;">\${texts.signature}</p>
            </div>
            <div style="background:#f8fafc; padding:16px 24px; text-align:center; border-top:1px solid #eef1f4;">
              <p style="font-size:11px; color:#9aa3ad; margin:0;">© Elakay · elakay.com</p>
            </div>
          </div>
          </div>
        `
      },
      {
        title: __elakayText("t004", "email Change Password"),
        data: {
          user: { firstname: "John", lastname: "Doe" },
          subject: "Elakay - Password Reset Request",
          token: "uniqueToken123",
          // Bug fix : "${token}" dans une chaîne entre guillemets simples ne
          // s'interpole jamais (ce n'est pas un template literal) — le lien
          // affichait littéralement "${token}" au lieu de la valeur réelle.
          url: "https://www.example.com/reset-password/uniqueToken123",
          urlLogo: "http://localhost:2284/elakay_api/icon/logo_elakay/logoelakay.ico",
          texts: {
            welcomeTitle: "Reset Your Password",
            introduction: ` we received a request to reset the password for your Elakay account.`,
            instructions: `To reset your password, please click the link below. This link will take you to a secure page where you can set a new password for your account.`,
            warning: `⚠️ For security purposes, this link will expire in 30 minutes. If you did not request a password reset, please ignore this email or contact our support team immediately.`,
            signature: `Thank you, The Elakay Team`
          }
        },
        htmlTemplate: `
          <div style="background:#f4f6f8; padding:32px 16px; font-family:Arial,Helvetica,sans-serif;">
          <style>
            @media only screen and (max-width:600px) {
              .elakay-card4 { border-radius:0 !important; }
              .elakay-body4 { padding:28px 22px !important; }
            }
          </style>
          <div class="elakay-card4" style="max-width:600px; width:100%; margin:0 auto; background:#ffffff; border-radius:14px; overflow:hidden; box-shadow:0 6px 24px rgba(0,59,79,0.12);">
            <div style="background:linear-gradient(135deg,#004b63 0%,#007399 60%,#00a4d8 100%); padding:32px 24px; text-align:center;">
              <img src="\${urlLogo}" alt="${infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).languageCodeEdit.t008}" style="width: 42px; height: 42px; vertical-align: middle; filter: brightness(0) invert(1); margin-right: 10px;">
              <span style="font-size: 26px; font-weight: bold; vertical-align: middle; color:#ffffff; letter-spacing:0.5px;">Elakay</span>
            </div>
            <div class="elakay-body4" style="padding: 36px 40px; color:#374151;">
              <h2 style="font-size: 22px; color: #0f2d3d; margin: 0 0 6px; font-weight:700;">\${texts.welcomeTitle}</h2>
              <p style="font-size: 15px; color:#6b7280; margin: 0 0 24px;">Hello \${user.firstname} \${user.lastname}</p>
              <p style="font-size: 15px; line-height: 1.7; margin-bottom: 14px;">\${texts.introduction}</p>
              <p style="font-size: 15px; line-height: 1.7; margin-bottom: 28px;">\${texts.instructions}</p>

              <div style="text-align:center; margin: 0 0 28px;">
                <a href="\${url}" style="display: inline-block; text-decoration: none; background-color: #007399; color: white; padding: 14px 36px; font-size: 15px; font-weight: bold; border-radius: 9px;">
                  Reset My Password
                </a>
              </div>

              <p style="font-size: 13px; color: #c0392b; background:#fff5f5; border-left:3px solid #c0392b; padding:10px 14px; border-radius:0 8px 8px 0; margin-bottom: 28px;">\${texts.warning}</p>

              <hr style="border:none; border-top:1px solid #eef1f4; margin:0 0 20px;">
              <p style="font-size: 13px; line-height: 1.6; color: #9aa3ad; margin:0;">\${texts.signature}</p>
            </div>
            <div style="background:#f8fafc; padding:16px 24px; text-align:center; border-top:1px solid #eef1f4;">
              <p style="font-size:11px; color:#9aa3ad; margin:0;">© Elakay · elakay.com</p>
            </div>
          </div>
          </div>
        `
      },
      {
        "title": __elakayText("t005", "about us"),
        "data": {
          "aboutUs": {
            "title0": "Who we are",
            "text00": "We are a community driven by a shared mission: to catalyze business growth and success across America. We believe in the power of collaboration, innovation, and mutual support to help our members - artisans, professionals, and business administrators - realize their full potential. Our goal is to create an ecosystem where every business, large or small, has the tools and resources to thrive.",
            "text01": "",
            "text02": "At Elakay, we are not just an e-commerce platform; we are a community committed to three core principles that guide everything we do: fostering growth, supporting small business, and celebrating individuality. These values are at the heart of everything we do and shape the unique experience we provide to our users. ",
            "title1": "Our vision",
            "text10": "Imagine a future where every entrepreneur finds a supportive community, accessible resources, and unlimited growth opportunities. We envision a world where barriers to entrepreneurship are lowered, innovation is fueled by diversity, and success is celebrated collectively.",
            "title2": "Our values",
            "text20": "our mission is based on three essential pillars: growth, support for small businesses, and individuality. We believe in the transformative impact of telecommunications technology to break down barriers, providing our sellers with expanded reach and our buyers with unprecedented diversity. Supporting small businesses is at the heart of our approach. By investing in these entities, we contribute to their evolution into large, successful companies, fostering a rich and diversified economic ecosystem. Individuality is our third pillar, encouraged through a platform that values and celebrates the unique expression of each seller. This approach guarantees a satisfying purchasing experience for our customers, enriched by the discovery of products that reflect the personality and creativity of their creators. At Elakay, we are dedicated to building a community where every member can grow, express themselves freely, and contribute to a dynamic and inclusive marketplace.",
            "list0": "Collaborative Platform: An online space to connect, learn, and grow together.",
            "list1": "Training and Mentoring: Programs designed to equip our members with the skills needed for success.",
            "list2": "Funding Support: Facilitate access to financial resources to transform ideas into thriving businesses.",
            "list3": "Promotion and Visibility: Providing channels to increase the reach and impact of our businesses.",
            "title3": "How We Act",
            "text30": "To realize our vision, we are implementing a series of strategic initiatives:",
            "list4": "Networking and Events: Organize enriching meetings to forge strong connections and discover new opportunities.",
            "title4": "Growth through Telecommunications",
            "text40": "In a world where technology is rapidly evolving, we recognize that access to effective means of communication is essential to drive growth. Elakay leverages telecommunications to break geographic and temporal barriers, allowing our sellers to reach a wider audience and our buyers to discover an unparalleled variety of products. This approach allows us to offer a platform where abundance of choice and ease of access go hand in hand with profitability.",
            "title5": "Support Small Businesses",
            "text50": "We firmly believe that supporting small businesses is the foundation of a thriving economy. At Elakay, every small business receives the support they need to grow and thrive. We invest in the success of \"underdogs\", providing them with the tools and resources to reach new heights. By highlighting these companies, we are helping to create an ecosystem where dreams come true and every effort is valued.",
            "title6": "Celebrating Individuality",
            "text60": "Creative expression and individuality are at the heart of our mission. Elakay actively encourages our sellers to innovate and express themselves in unique ways. We offer them a platform where their uniqueness is not only accepted, but also celebrated. This commitment to individuality ensures that our buyers not only find products that meet their needs, but also items that bring a personal and original touch to their everyday lives.",
            "title7": "Together Towards a Promising Future",
            "text70": "With these principles in action, Elakay proudly stands as a trusted partner for your purchases. We are committed to providing an enriching experience for all of our users, whether they are buyers looking for unique products or sellers aspiring to expand their reach. Together, we are building a future where every purchase is a source of pride and every sale a step toward success.",
            "text71": "",
            "text72": "Join us on this adventure. At Elakay, your growth is our success, and your individuality is our inspiration. Together, let's shape a world where small businesses flourish and every voice is heard.",
            "url": "http://localhost?aboutus=true"
          },
          
        },
        htmlTemplate: `
  <div style="background:#f4f6f8; padding:32px 16px; font-family:Arial,Helvetica,sans-serif;">
  <style>
    @media only screen and (max-width:600px) {
      .elakay-card5 { border-radius:0 !important; }
      .elakay-body5 { padding:28px 22px !important; }
    }
  </style>
  <div class="elakay-card5" style="max-width: 600px; width:100%; margin: 0 auto; background-color: #ffffff; border-radius: 14px; overflow:hidden; box-shadow:0 6px 24px rgba(0,59,79,0.12);">
    <div style="background:linear-gradient(135deg,#004b63 0%,#007399 60%,#00a4d8 100%); padding:32px 24px; text-align:center;">
      <span style="font-size: 22px; font-weight: bold; color:#ffffff; letter-spacing:0.5px;">${infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).languageCodeEdit.t009}</span>
    </div>
    <div class="elakay-body5" style="padding: 36px 40px; color:#374151;">
      <h3 style="color: #007399; font-size: 18px; margin: 0 0 10px; border-left:3px solid #007399; padding-left:12px;">\${aboutUs.title0}</h3>
      <p style="font-size: 15px; line-height: 1.7; margin-bottom: 14px;">\${aboutUs.text00}</p>
      <p style="font-size: 15px; line-height: 1.7; margin-bottom: 14px;">\${aboutUs.text01}</p>
      <p style="font-size: 15px; line-height: 1.7; margin-bottom: 28px;">\${aboutUs.text02}</p>

      <h3 style="color: #007399; font-size: 18px; margin: 0 0 10px; border-left:3px solid #007399; padding-left:12px;">\${aboutUs.title1}</h3>
      <p style="font-size: 15px; line-height: 1.7; margin-bottom: 28px;">\${aboutUs.text10}</p>

      <h3 style="color: #007399; font-size: 18px; margin: 0 0 10px; border-left:3px solid #007399; padding-left:12px;">\${aboutUs.title2}</h3>
      <p style="font-size: 15px; line-height: 1.7; margin-bottom: 16px;">\${aboutUs.text20}</p>

      <div style="background:#f0f8fb; border:1px solid #b3dde8; border-radius:12px; padding:18px 20px 4px; margin-bottom: 28px;">
        <p style="font-size: 14px; line-height: 1.6; margin:0 0 14px; color:#0f2d3d;">✓&nbsp; \${aboutUs.list0}</p>
        <p style="font-size: 14px; line-height: 1.6; margin:0 0 14px; color:#0f2d3d;">✓&nbsp; \${aboutUs.list1}</p>
        <p style="font-size: 14px; line-height: 1.6; margin:0 0 14px; color:#0f2d3d;">✓&nbsp; \${aboutUs.list2}</p>
        <p style="font-size: 14px; line-height: 1.6; margin:0 0 14px; color:#0f2d3d;">✓&nbsp; \${aboutUs.list3}</p>
      </div>

      <div style="text-align:center;">
        <a href="\${aboutUs.url}" style="display: inline-block; text-align: center; background-color: #007399; color: white; padding: 14px 36px; font-size: 15px; font-weight: bold; border-radius: 9px; text-decoration: none;">
          See More
        </a>
      </div>
    </div>
    <div style="background:#f8fafc; padding:16px 24px; text-align:center; border-top:1px solid #eef1f4;">
      <p style="font-size:11px; color:#9aa3ad; margin:0;">© Elakay · elakay.com</p>
    </div>
  </div>
  </div>
      ` },
      {
        _id: "675d14b39be5667e99431b8c",
        title: __elakayText("t006", "email Sell Product"),
        data: {
          user: { firstname: "intel", lastname: "travail" },
          products: [
            {
              productID: "66549a1eb442b8a33ad49f9b",
              urlImg: "http://localhost:2284/elakay_api/img/67664f839fd670bbbf03d019/67664faa9fd670bbbf03d03c",
              filterPro: "66549a2bb442b8a33ad49fb9",
              price: 22,
              salePrice: 0,
              count: 1,
              status: "Not processed",
              _id: "675d14b39be5667e99431b8d",
              createdAt: "2024-12-14T05:16:35.387Z",
              updatedAt: "2024-12-14T05:16:35.387Z"
            }
          ],
          shippingAddress: {
            firstName: "intel",
            lastName: "travail",
            tel: "+1 347 781 3174",
            line1: "1091 Hancock St",
            city: "Brooklyn",
            state: "New York",
            postal_code: "11221",
            country: "US"
          },
          amountTotal: 30.45
        },
        htmlTemplate: `
          <div style="background:#f4f6f8; padding:32px 16px; font-family:Arial,Helvetica,sans-serif;">
          <style>
            @media only screen and (max-width:600px) {
              .elakay-card6 { border-radius:0 !important; }
              .elakay-body6 { padding:28px 22px !important; }
            }
            @media only screen and (max-width:480px) {
              .elakay-product-card { width:100% !important; max-width:100% !important; margin:0 0 16px 0 !important; }
            }
          </style>
          <div class="elakay-card6" style="max-width: 600px; width:100%; margin: 0 auto; background-color: #ffffff; border-radius: 14px; overflow:hidden; box-shadow:0 6px 24px rgba(0,59,79,0.12);">
            <!-- Header -->
            <div style="background:linear-gradient(135deg,#004b63 0%,#007399 60%,#00a4d8 100%); padding:28px 24px; text-align: center;">
              <span style="font-size: 24px; font-weight: bold; color:#ffffff; letter-spacing:0.5px;">Elakay</span>
            </div>

            <!-- Content -->
            <div class="elakay-body6" style="padding: 36px 40px; color:#374151;">
              <h2 style="font-size: 20px; color: #0f2d3d; margin: 0 0 6px; font-weight:700;">${infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).languageCodeEdit.t010}</h2>
              <div style="background:#f0f8fb; border:1px solid #b3dde8; border-radius:10px; padding:14px 18px; margin-bottom: 24px;">
                <p style="font-size: 14px; margin:0; color:#0f2d3d;">A customer purchased <strong>\${products[0].count}</strong> of your product(s) on Elakay.com</p>
              </div>

              <!-- Product row : empile en 1 colonne sous 480px, cartes flottantes sinon -->
              <div style="text-align: center; margin: 0 -8px 28px;">
                \${products}
              </div>

              <!-- Shipping Address -->
              <h4 style="font-size: 15px; color: #007399; margin: 0 0 10px; text-transform:uppercase; letter-spacing:0.06em;">${infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).languageCodeEdit.t011}</h4>
              <div style="background:#f8fafc; border:1px solid #eef1f4; border-radius:10px; padding:16px 18px; margin-bottom: 28px;">
                <p style="font-size: 14px; line-height: 1.7; margin:0; color:#374151;">
                  \${shippingAddress.firstName} \${shippingAddress.lastName}<br>
                  \${shippingAddress.line1}, \${shippingAddress.city}, \${shippingAddress.state}<br>
                  \${shippingAddress.postal_code}, \${shippingAddress.country}<br>
                  Tel: \${shippingAddress.tel}
                </p>
              </div>

              <!-- Call to Action -->
              <p style="font-size: 14px; line-height: 1.6; text-align: center; color:#6b7280; margin-bottom: 18px;">
                Please click the button below to view this order.
              </p>

              <div style="text-align: center;">
                <a href="#" style="display:inline-block; text-decoration: none; background-color: #007399; color: white; padding: 14px 36px; font-size: 15px; font-weight: bold; border-radius: 9px;">
                  View Order
                </a>
              </div>
            </div>
            <div style="background:#f8fafc; padding:16px 24px; text-align:center; border-top:1px solid #eef1f4;">
              <p style="font-size:11px; color:#9aa3ad; margin:0;">© Elakay · elakay.com</p>
            </div>
          </div>
          </div>
        `
      } ,
      {
        _id: "66ee07a56b836a92ce1f3460",
        title: __elakayText("t007", "email Payment Success"),
        data: {
          user: { firstname: "John", lastname: "Doe" },
          subject: "Elakay - Payment Confirmation",
          trackingUrl: "https://www.example.com/track-order/uniqueTracking123",
          viewOrderUrl: "https://www.example.com/view-order/uniqueOrder123",
          urlLogo: "http://localhost:2284/elakay_api/icon/logo_elakay/logoelakay.ico",
          orderImageUrl: "http://localhost:2284/elakay_api/img/67664f839fd670bbbf03d019/67664faa9fd670bbbf03d03c",
          texts: {
            welcomeTitle: "Payment Successful!",
            introduction: `your payment has been successfully processed.`,
            shippingInfo: `Your order is now being prepared for shipping. You can track your shipment using the link below:`,
            trackingLabel: "Track Your Order",
            viewOrderLabel: "View Order",
            closingMessage: `Thank you for shopping with Elakay! Your support helps our community grow stronger. Together, we're building a network of thriving entrepreneurs and satisfied customers.`,
            signature: `Best regards, The Elakay Team`
          }
        },
        htmlTemplate: `
          <div style="background:#f4f6f8; padding:32px 16px; font-family:Arial,Helvetica,sans-serif;">
          <style>
            @media only screen and (max-width:600px) {
              .elakay-card7 { border-radius:0 !important; }
              .elakay-body7 { padding:28px 22px !important; }
            }
          </style>
          <div class="elakay-card7" style="max-width: 600px; width:100%; margin: 0 auto; background-color: #ffffff; border-radius: 14px; overflow:hidden; box-shadow:0 6px 24px rgba(0,59,79,0.12);">
            <!-- Header -->
            <div style="background:linear-gradient(135deg,#004b63 0%,#007399 60%,#00a4d8 100%); padding:32px 24px; text-align: center;">
              <img src="\${urlLogo}" alt="${infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).languageCodeEdit.t012}" style="width: 42px; height: 42px; vertical-align: middle; filter: brightness(0) invert(1); margin-right: 10px;">
              <span style="font-size: 26px; font-weight: bold; vertical-align: middle; color:#ffffff; letter-spacing:0.5px;">Elakay</span>
            </div>

            <!-- Content -->
            <div class="elakay-body7" style="padding: 36px 40px; color:#374151; text-align:center;">
              <span style="display:inline-block; width:52px; height:52px; line-height:52px; border-radius:50%; background:#e9f9ef; color:#16a34a; font-size:26px; font-weight:bold; margin-bottom:16px;">✓</span>
              <h2 style="font-size: 22px; color: #0f2d3d; margin: 0 0 6px; font-weight:700;">\${texts.welcomeTitle}</h2>
              <p style="font-size: 15px; color:#6b7280; margin: 0 0 20px;">Hello \${user.firstname} \${user.lastname}</p>
              <p style="font-size: 15px; line-height: 1.7; margin-bottom: 8px;">\${texts.introduction}</p>
              <p style="font-size: 15px; line-height: 1.7; margin-bottom: 24px;">\${texts.shippingInfo}</p>

              <!-- Order Image -->
              <div style="margin-bottom: 24px;">
                <a href="\${viewOrderUrl}" style="text-decoration: none;">
                  <img
                    src="\${orderImageUrl}"
                    alt="${infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).languageCodeEdit.t013}"
                    style="max-width: 60%; height: auto; border-radius: 10px; border:1px solid #eef1f4;"
                  />
                </a>
              </div>

              <!-- Tracking Button -->
              <div style="margin-bottom: 24px;">
                <a href="\${trackingUrl}" style="display: inline-block; text-decoration: none; background-color: #007399; color: white; padding: 14px 36px; font-size: 15px; font-weight: bold; border-radius: 9px;">
                  \${texts.trackingLabel}
                </a>
              </div>

              <p style="font-size: 13px; line-height: 1.6; color:#6b7280; margin-bottom: 24px;">\${texts.closingMessage}</p>

              <hr style="border:none; border-top:1px solid #eef1f4; margin:0 0 20px;">
              <p style="font-size: 13px; line-height: 1.6; color: #9aa3ad; margin:0;">\${texts.signature}</p>
            </div>
            <div style="background:#f8fafc; padding:16px 24px; text-align:center; border-top:1px solid #eef1f4;">
              <p style="font-size:11px; color:#9aa3ad; margin:0;">© Elakay · elakay.com</p>
            </div>
          </div>
          </div>
        `
      }
          
    ];
    
    const productTemplate = `
    <div class="elakay-product-card" style="display:inline-block; vertical-align:top; width:46%; max-width:180px; margin:0 1.5% 16px; box-sizing:border-box; text-align: center; border: 1px solid #eef1f4; background:#ffffff; padding: 12px; border-radius: 10px; box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.06);">
      <a href="#" style="text-decoration: none;">
        <img
          src="{urlImg}"
          alt="${infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).languageCodeEdit.t014}"
          style="width: 100%; height: 110px; object-fit: cover; border-radius: 8px; margin-bottom: 10px; display:block;"
        />
      </a>
      <p style="font-size: 14px; margin: 0 0 4px; color:#007399; font-weight:700;">${infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).languageCodeEdit.t015} $${"{price}"}</p>
      <p style="font-size: 12px; margin: 0; color:#9aa3ad;">${infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).languageCodeEdit.t016} ${"{count}"}</p>
    </div>
  `;
   

let exempleJSOM = {
    "user": {
      "firstname": "John",
      "lastname": "Doe"
    },
    "random": 123456,
    "url": "https://www.example.com",
    "urlLogo": "http://localhost:2284/elakay_api/icon/logo_elakay/logoelakay.ico",
    "texts": {
      "welcomeTitle": "Welcome to elakay",
      "clickButton": "Please click the button below to validate your elakay account",
      "secureVerification": "And enter this secure verification",
      "codeText": "Code",
      "expiryText": "The secure verification will expire in 20 minutes",
      "accountRemoval": "If you do not activate your account in 7 days, your account will be removed from elakay data"
    },
     "images": {
      "logo": "http://localhost:2284/elakay_api/img/66776a15e7bf6478e57c12cf/66776a54e7bf6478e57c1309",
      "banner": "http://localhost:2284/elakay_api/pubXL/665274be4fe5fe9d482da097/66bbd36043543ff95d6fa969"
    },     
}

  const exmpleHTML_CSS = `
    <div style="background:#f4f6f8; padding:32px 16px; font-family:Arial,Helvetica,sans-serif;">
    <style>
      @media only screen and (max-width:600px) {
        .elakay-card-ex { border-radius:0 !important; }
        .elakay-body-ex { padding:28px 22px !important; }
      }
    </style>

    <!-- Account Validation Section -->
    <div class="elakay-card-ex" style="max-width:600px; width:100%; margin: 0 auto 24px; background:#ffffff; border-radius: 14px; overflow:hidden; box-shadow:0 6px 24px rgba(0,59,79,0.12); text-align:center;">
      <div style="background:linear-gradient(135deg,#004b63 0%,#007399 60%,#00a4d8 100%); padding:28px 24px;">
        <img src="\${urlLogo}" alt="${infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).languageCodeEdit.t017}" style="width:30px; height:30px; vertical-align: middle; margin-right: 10px; display: inline; filter: brightness(0) invert(1);">
        <span style="font-size:24px; font-weight:700; color:#ffffff; vertical-align:middle; letter-spacing:0.5px;">elakay</span>
      </div>
      <div class="elakay-body-ex" style="padding: 36px 40px; color:#374151;">
        <h2 style="font-size: 20px; color: #0f2d3d; margin:0 0 18px; font-weight:700;">\${texts.welcomeTitle}</h2>
        <h3 style="font-size: 15px; color:#6b7280; margin:0 0 20px; font-weight:600;">\${user.firstname} \${user.lastname}</h3>
        <img src="\${images.logo}" alt="${infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).languageCodeEdit.t018}" style="width:120px; height:120px; border-radius:10px; margin-bottom:20px;" />
        <p style="font-size: 15px; line-height:1.7; margin: 0 0 14px;">\${texts.clickButton}</p>
        <p style="font-size: 15px; line-height:1.7; margin: 0 0 20px;">\${texts.secureVerification}</p>

        <div style="background:#f0f8fb; border:1px solid #b3dde8; border-radius: 12px; padding: 20px; margin: 0 0 16px;">
          <span style="display:block; font-size:11px; font-weight:700; color:#007399; text-transform:uppercase; letter-spacing:0.12em; margin-bottom:8px;">\${texts.codeText}</span>
          <span style="font-size:30px; font-weight:700; color:#004b63; letter-spacing:6px;">\${random}</span>
        </div>

        <p style="font-size: 13px; color: #c0392b; background:#fff5f5; border-left:3px solid #c0392b; padding:10px 14px; border-radius:0 8px 8px 0; margin-bottom: 24px; text-align:left;">\${texts.expiryText}</p>
        <p style="font-size: 13px; line-height: 1.6; color:#6b7280; margin-bottom: 24px;">\${texts.accountRemoval}</p>

        <img src="\${images.banner}" alt="${infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).languageCodeEdit.t019}" style="width:100%; height:auto; border-radius:10px; margin-bottom:24px;" />

        <a href="\${url}" style="display: inline-block; text-decoration: none; background-color: #007399; color: white; padding: 14px 36px; font-size: 15px; font-weight: bold; border-radius: 9px;">
          Click here
        </a>
      </div>
    </div>

    <!-- About Us Section -->
    <div class="elakay-card-ex" style="max-width: 600px; width:100%; margin: 0 auto; background-color: #ffffff; border-radius: 14px; overflow:hidden; box-shadow:0 6px 24px rgba(0,59,79,0.12);">
      <div style="background:linear-gradient(135deg,#004b63 0%,#007399 60%,#00a4d8 100%); padding:28px 24px; text-align:center;">
        <span style="font-size: 20px; font-weight: bold; color:#ffffff; letter-spacing:0.5px;">${infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).languageCodeEdit.t020}</span>
      </div>
      <div class="elakay-body-ex" style="padding: 36px 40px; color:#374151;">
        <h3 style="color: #007399; font-size: 18px; margin: 0 0 10px; border-left:3px solid #007399; padding-left:12px;">\${aboutUs.title0}</h3>
        <p style="font-size: 15px; line-height: 1.7; margin-bottom: 14px;">\${aboutUs.text00}</p>
        <p style="font-size: 15px; line-height: 1.7; margin-bottom: 14px;">\${aboutUs.text01}</p>
        <p style="font-size: 15px; line-height: 1.7; margin-bottom: 28px;">\${aboutUs.text02}</p>

        <h3 style="color: #007399; font-size: 18px; margin: 0 0 10px; border-left:3px solid #007399; padding-left:12px;">\${aboutUs.title1}</h3>
        <p style="font-size: 15px; line-height: 1.7; margin-bottom: 28px;">\${aboutUs.text10}</p>

        <h3 style="color: #007399; font-size: 18px; margin: 0 0 10px; border-left:3px solid #007399; padding-left:12px;">\${aboutUs.title2}</h3>
        <p style="font-size: 15px; line-height: 1.7; margin-bottom: 16px;">\${aboutUs.text20}</p>

        <div style="background:#f0f8fb; border:1px solid #b3dde8; border-radius:12px; padding:18px 20px 4px; margin-bottom: 28px;">
          <p style="font-size: 14px; line-height: 1.6; margin:0 0 14px; color:#0f2d3d;">✓&nbsp; \${aboutUs.list0}</p>
          <p style="font-size: 14px; line-height: 1.6; margin:0 0 14px; color:#0f2d3d;">✓&nbsp; \${aboutUs.list1}</p>
          <p style="font-size: 14px; line-height: 1.6; margin:0 0 14px; color:#0f2d3d;">✓&nbsp; \${aboutUs.list2}</p>
          <p style="font-size: 14px; line-height: 1.6; margin:0 0 14px; color:#0f2d3d;">✓&nbsp; \${aboutUs.list3}</p>
        </div>

        <div style="text-align:center;">
          <a href="\${aboutUs.url}" style="display: inline-block; text-align: center; background-color: #007399; color: white; padding: 14px 36px; font-size: 15px; font-weight: bold; border-radius: 9px; text-decoration: none;">
            See More
          </a>
        </div>
      </div>
      <div style="background:#f8fafc; padding:16px 24px; text-align:center; border-top:1px solid #eef1f4;">
        <p style="font-size:11px; color:#9aa3ad; margin:0;">© Elakay · elakay.com</p>
      </div>
    </div>
    </div>


  `
  const user = {
    fullName: "John Doe",
    email: "john.doe@example.com",
    verificationCode: "123456"
  };

//   const generateEmailTemplate = (user) => `
//   <div style="text-align: center; font-family: Arial, sans-serif; width: 100%; background-color: #f4f4f4; padding: 20px;">
//     <div style="max-width: 600px; margin: auto; background-color: white; border-radius: 10px; overflow: hidden;">
//       <h1 style="background-color: #007399; color: white; padding: 15px; font-size: 24px;">
//         Elakay Security Alert
//       </h1>
//       <div style="padding: 20px; text-align: left;">
//         <p style="font-size: 16px; color: #333;">Hello <strong>${user.fullName}</strong>,</p>
//         <p style="font-size: 16px; color: #333;">
//           We noticed a login attempt on your Elakay account from a new device. For security reasons, we require you to verify this attempt by entering the code below. This code will expire in 20 minutes.
//         </p>

//         <h2 style="font-size: 28px; color: #007399; text-align: center; letter-spacing: 2px; margin: 20px 0;">
//           ${user.verificationCode}
//         </h2>

//         <p style="font-size: 16px; color: #333;">
//           <strong>Email:</strong> ${user.email}
//         </p>
        
//         <p style="font-size: 16px; color: #333;">
//           Please enter this code in your Elakay app to complete the verification.
//         </p>

//         <p style="font-size: 16px; color: #333;">
//           If you did not attempt to sign in, please secure your account immediately by changing your password.
//         </p>

//         <p style="font-size: 16px; color: #333;">Thank you,<br/>The Elakay Team</p>
//       </div>

//       <div style="background-color: #f4f4f4; padding: 10px; text-align: center;">
//         <p style="font-size: 12px; color: #888;">
//           This code will expire in 20 minutes. If you did not request this, please ignore this email.
//         </p>
//       </div>
//     </div>
//   </div>
// `;

// const generateEmailTemplate1 = (user, token) => `
// <div style="text-align: center; font-family: Arial, sans-serif; width: 100%; background-color: #f4f4f4; padding: 20px;">
//   <div style="max-width: 600px; margin: auto; background-color: white; border-radius: 10px; overflow: hidden;">
//     <h1 style="background-color: #007399; color: white; padding: 15px; font-size: 24px;">
//       Elakay Account Confirmation
//     </h1>
//     <div style="padding: 20px; text-align: left;">
//       <p style="font-size: 16px; color: #333;">Hello <strong>${user.fullName}</strong>,</p>
//       <p style="font-size: 16px; color: #333;">
//         Thank you for signing up on Elakay! To activate your account, please verify your email address by clicking the button below. This code will expire in 20 minutes.
//       </p>

//       <h2 style="font-size: 28px; color: #007399; text-align: center; letter-spacing: 2px; margin: 20px 0;">
//         ${user.verificationCode}
//       </h2>

//       <p style="font-size: 16px; color: #333;">
//         <strong>Email:</strong> ${user.email}
//       </p>
      
//       <a href="https://elakay.com/active/${token}" style="display: inline-block; padding: 10px 20px; background-color: #007399; color: white; border-radius: 25px; font-size: 16px; text-decoration: none; margin-top: 20px;">
//         Activate Account
//       </a>

//       <p style="font-size: 16px; color: #333;">
//         If you did not sign up, you can ignore this email.
//       </p>

//       <p style="font-size: 16px; color: #333;">Thank you,<br/>The Elakay Team</p>
//     </div>

//     <div style="background-color: #f4f4f4; padding: 10px; text-align: center;">
//       <p style="font-size: 12px; color: #888;">
//         This link will expire in 20 minutes.
//       </p>
//     </div>
//   </div>
// </div>
// `;
    

const defExempleJSOM =  '<!-- enter your combined JSON here... -->'
    const defExmpleHTML_CSS = '<!-- enter your HTML Et CSS template here...-->'

    // JSON combiné pour les informations utilisateur et les textes des sections Account Validation et About Us
  const [jsonInput, setJsonInput] = useState(defExempleJSOM);

  // HTML combiné pour la validation de compte et la section "About Us"
  const [htmlTemplate, setHtmlTemplate] = useState(defExmpleHTML_CSS);

  const  selEmailType = [__elakayText("t005", "about us"), __elakayText("t001", "send e-mail confirmation"), __elakayText("t002", "send e-mail verificatiom"), __elakayText("t003", "resend Code Verification"), __elakayText("t004", "email Change Password"), __elakayText("t010", "email Actiivation Role"), __elakayText("t006", "email Sell Product"), __elakayText("t011", "email Markerting User"), __elakayText("t012", "email New Product User"), __elakayText("t013", "email Shop Product User"), __elakayText("t007", "email Payment Success")]
  const [deletePara, setDeletePara] = useState(false);
  const [checkdeletePara, setCheckDeletePara] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const [srcDoc, setSrcDoc] = useState(''); 
  const [getTilte, setTilte] = useState('')
  let ObjetPage = {
    data: "",
    htmlTemplate : ""
  }
  const[paragra, setParagra]= useState(ObjetPage)


const replaceAray = (array, obj,  key, arrayRepl)=>{
    let linkData
    let data
    for (let i = 0; i < array?.length; i++) {
        linkData = "${"+ key +"." + array[i] + "}"
        data = obj[key][array[i]]
        arrayRepl.push([linkData, data])
    }  
}

const checkIfFunction = (f)=>{
  return typeof f === 'object' ? true : false
}

const checkIfArray = (value) => {
  return Array.isArray(value) ? true : false;
};

const replaceArray = (array, key, arrayRepl) => {
  if(key ==='products'){
    // Bloc groupé ${products} (cartes produit)
    const productCards = array?.map((product) => {
      return productTemplate
        .replace("{urlImg}", product.urlImg)
        .replace("{price}", product.price)
        .replace("{count}", product.count);
    })
    .join("");
    let linkData = "${" + key + "}";
    arrayRepl.push([linkData, productCards]);
    // Bug fix : ${products} ne couvrait pas les accès indexés comme
    // ${products[0].count} utilisés dans le template "Sell Product" —
    // on génère donc aussi les entrées indexées ci-dessous.
  }
  array.forEach((item, index) => {
    if (checkIfFunction(item)) {
      // Handle objects inside the array
      Object.keys(item).forEach((subKey) => {
        const linkData = "${" + key + "[" + index + "]." + subKey + "}";
        arrayRepl.push([linkData, item[subKey]]);
      });
    } else {
      // Handle primitive values inside the array
      const linkData = "${" + key + "[" + index + "]}";
      arrayRepl.push([linkData, item]);
    }
  });
};

const replaceObj = (array, obj,  key, arrayRepl)=>{
    let linkData
    let data
    for (let i = 0; i < array?.length; i++) {
        linkData = "${"+ key +"." + array[i] + "}"
        data = obj[key][array[i]]
        arrayRepl.push([linkData, data])
    }  
}


  const secondaireData = (prObj, seObj, key, arrayRepl)=>{
    let newArray
    let linkData
    let data 
    if (checkIfArray(seObj)) {
      // Handle array case
      replaceArray(seObj, key, arrayRepl);
    } else if (checkIfFunction(seObj)) {
      // Handle object case
      newArray = Object.keys(seObj ? seObj : {});
      replaceObj(newArray, prObj, key, arrayRepl);
    } else {
      // Handle primitive case
      linkData = "${" + key + "}";
      data = prObj[key];
      arrayRepl.push([linkData, data]);
    }
  }


const htmlReplaceData = (obj)=>{
    let arrayRepl = []
   let primaireData = Object.keys(obj ? obj:{});
   primaireData.forEach((da => secondaireData(obj, obj[da], da, arrayRepl)))
   return arrayRepl
}
  // runTemplate prend le JSON/HTML en paramètres (plutôt que de lire l'état
  // React directement) pour pouvoir être appelée juste après un setState
  // (ex: handleTilteData) sans tomber sur les valeurs d'état encore non
  // mises à jour (bug de "stale closure").
  const runTemplate = (jsonStr, htmlStr) => {
    try {
      setSrcDoc('');
      // Parse le JSON entré par l'utilisateur
      const data = JSON.parse(jsonStr);
      // Remplacer les placeholders dans le HTML avec les valeurs du JSON
      let dynamicHtml = htmlStr;
      const arrayReplace = htmlReplaceData(data);
      for (let i = 0; i < arrayReplace?.length; i++) {
          const linkName = arrayReplace[i][0];
          const name = arrayReplace[i][1];
          // Bug fix : .replace() ne remplaçait que la 1ère occurrence d'un
          // même placeholder ; split/join remplace toutes les occurrences.
          dynamicHtml = dynamicHtml.split(linkName).join(name === undefined || name === null ? '' : String(name));
      }

      // Utilisation du HTML combiné et affichage du contenu dans un iframe
      setSrcDoc(dynamicHtml);
      setErrorMessage(null);
    } catch (error) {
      setSrcDoc('');
      setErrorMessage(elakayAutoText("h_3e885b57a51a6b", "Erreur de syntaxe JSON : {value0}", { value0: error.message }));
    }
  };

  // Fonction qui sera appelée au clic du bouton "Run"
  const handleRunCode = () => runTemplate(jsonInput, htmlTemplate);
  
  const convertArrayToObject = (array) => {
    const aboutUs = {};
    
    array.forEach((item, index) => {
      // Ajouter le titre
      aboutUs[`title${index}`] = item.title;
      
      // Ajouter les textes
      item.text.forEach((text, textIndex) => {
        aboutUs[`text${index}${textIndex}`] = text;
      });
  
      // Ajouter les éléments de la liste s'il y en a
      if (item.list?.length > 0) {
        item.list.forEach((listItem, listIndex) => {
          aboutUs[`list${listIndex}`] = listItem;
        });
      }
    });
  
    // Ajouter un URL fixe comme dans l'exemple donné
    aboutUs['url'] = 'http://localhost?aboutus=true';
  
    return aboutUs;
  }

  const checkButton = (name)=>{
    if(name === 'JSON'){
        if(jsonInput !== defExempleJSOM){
             return false
        }else{
            return true
        }
    }else if(name === 'HTML'){
        if(htmlTemplate !== defExmpleHTML_CSS){
            return false
        }else{
            return true
        }
}
  }
  let aboutUs = convertArrayToObject(infoSource.laguangeElakay('aboutUs',  infoSource.languageAPI))

const getExemple = (name)=>{ 
  
  let objt = emailTemplates.find(objt => objt.title === getTilte)
 
    if(name === 'JSON'){
      
        if(checkButton(name)){
          exempleJSOM.aboutUs = aboutUs 
          let Jsom =  objt ? objt: {data:  exempleJSOM}
            // exempleJSOM.aboutUs = aboutUs
            let exemple = JSON.stringify(Jsom.data,  null, 2)
            setJsonInput(exemple)
        }else{
            setJsonInput('<!-- enter your combined JSON here... -->')
        }
    }else if(name === 'HTML'){
        if(checkButton(name)){
          let html = objt ? objt.htmlTemplate :  exmpleHTML_CSS
            setHtmlTemplate(html)
        }else{
            setHtmlTemplate('<!-- enter your HTML Et CSS template here...-->')
        }
    }
}
const buttonAdd =()=>{
  try {
    let data = JSON.parse(jsonInput)
        data.title = getTilte
        
    updateLanguageElakay0(languageTradictor._id, token, {[nameObj]: {_id: paragra._id, data, htmlTemplate}}, true).then(data => {
        if (data.error) {
            setErrorMessage(data.error)
        } else {
            setJsonInput('<!-- enter your combined JSON here... -->')
            setHtmlTemplate('<!-- enter your HTML Et CSS template here...-->')
            setTilte('')
            AlllanguageSelect()
            languageUsertra()
            setEditAdd(true)
            setParagra(ObjetPage)    
    }})
    }catch (error) {
    // Afficher l'erreur si le parsing échoue
    setErrorMessage(elakayAutoText("h_3e885b57a51a6b", "Erreur de syntaxe JSON : {value0}", { value0: error.message }));
  }

}
const buttonDelPara =()=>{
    deleteLanguageElakay0(languageTradictor._id, paragra._id, nameObj, token, undefined).then(data => {
        if (data.error) {
            setErrorMessage(data.error)
        } else {
            AlllanguageSelect()
            languageUsertra()
            setCheckDeletePara(false)
            setDeletePara(false)
            // setEditAdd(true)
            setParagra(ObjetPage)  
    }
    })
}

  const btnActiveExmple = () => (
    <div className="code-edit-toolbar">
        <button className="code-edit-btn code-edit-btn-primary" onClick={() => buttonAdd()}>
            <FaSave />{infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).languageCodeEdit.t025}
        </button>
        <button className="code-edit-btn code-edit-btn-secondary" onClick={() => setShowEmailPage(true)}>
            <FaDesktop />{infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).languageCodeEdit.t026}
        </button>
        <button className="code-edit-btn code-edit-btn-primary" onClick={handleRunCode}>
            <FaPlay />{infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).languageCodeEdit.t027}
        </button>
    </div>
  );

  const pageIframe = () => (
      <div>
          {srcDoc && <h3 className="code-edit-preview-title"><FaEye />{infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).languageCodeEdit.t028}</h3>}
          {srcDoc && (
              <iframe
                  srcDoc={srcDoc}
                  title={infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).languageCodeEdit.t029}
                  sandbox="allow-scripts"
                  className="code-edit-iframe"
              />
          )}
      </div>
  );

const deleteAgree = () => {

    return (
        <Modal
            size="xl"
            show={deletePara}
            onHide={() => setDeletePara(false)}
            dialogClassName="modal-90w"
            aria-labelledby="example-custom-modal-styling-title"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="example-custom-modal-styling-title">
                    <h4 className="text-center text-danger m-0">
                        {infoSource.language(infoSource, "title", "delThtems")}
                    </h4>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {/* Bug fix : ce textarea affichait `paragra` mais son onChange
                    modifiait `jsonInput` (deux états différents) — il ne servait
                    donc qu'à relire l'élément avant suppression, jamais à
                    l'éditer. On le rend explicitement readOnly. */}
                <textarea
                    className="code-edit-delete-textarea"
                    value={JSON.stringify(paragra, null, 3)}
                    readOnly
                    placeholder={infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).languageCodeEdit.t030}
                />
                <div className="code-edit-delete-warning">
                    <FaExclamationTriangle />
                    <span>{elakayAutoText("h_951f495b348745", "This action cannot be undone.")}</span>
                </div>
                <div className="form-check">
                    <input
                        onChange={() => setCheckDeletePara(checkdeletePara ? false : true)}
                        type="checkbox"
                        className="form-check-input"
                        checked={checkdeletePara}
                        readOnly
                        id="chButAgree"
                    />
                    <label className="form-check-label" htmlFor="chButAgree">
                        {infoSource.language(infoSource, "title", "chButAgree")}
                    </label>
                </div>

                <div className="code-edit-toolbar">
                    {paragra._id !== undefined && checkdeletePara ? (
                        <button onClick={() => buttonDelPara()} className="code-edit-btn code-edit-btn-danger">
                            <FaTrashAlt />{infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).languageCodeEdit.t031}
                        </button>
                    ) : (
                        <button className="code-edit-btn code-edit-btn-danger" disabled>
                            <FaTrashAlt />{infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).languageCodeEdit.t032}
                        </button>
                    )}
                </div>
            </Modal.Body>
        </Modal>
    )
}

const printListeShop = () => (
    <Modal
        size="xl"
        show={showEmailPage}
        onHide={() => setShowEmailPage(false)}
        dialogClassName="modal-90w"
        aria-labelledby="example-custom-modal-styling-title"
        centered
    >
        <Modal.Header closeButton>
            <Modal.Title id="example-custom-modal-styling-title">
                <FaDesktop />{" "}{infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).languageCodeEdit.t026}
            </Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <div className="code-edit-picker">
                <div className="code-edit-picker-field">{selectObArData()}</div>
            </div>
            <div className="code-edit-toolbar">
                <button className="code-edit-btn code-edit-btn-primary" onClick={handleRunCode}>
                    <FaPlay />{infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).languageCodeEdit.t033}
                </button>
            </div>
            {pageIframe()}
        </Modal.Body>
    </Modal>
)


 const checkObjEmpty = (a)=>{
    return JSON.stringify(a) === '{}'

}

const handleTilte = () => event => {
    const value = event.target.value;
    checkTitleIsOk(languageTradictor[nameObj], value)
    setTilte(value)

};

const handleTilteData = () => event => {
    const value = event.target.value;
    const selected = languageTradictor[nameObj][value];
    const jsonStr = JSON.stringify(selected.data, null, 2);

    setParagra(selected);
    setTilte(selected.data.title);
    setJsonInput(jsonStr);
    setHtmlTemplate(selected.htmlTemplate);

    // Bug fix : handleRunCode() lisait jsonInput/htmlTemplate depuis l'état
    // React, qui n'est pas encore mis à jour juste après les setState
    // ci-dessus (closure périmée). On passe donc les valeurs fraîches
    // directement à runTemplate.
    runTemplate(jsonStr, selected.htmlTemplate);
};

const selectObAr =()=>{
    return <div className="code-edit-picker-field">
           <label>{__elakayText("t008", "all title for edit")}</label>
           <select value={getTilte} onChange={handleTilte()}>
           <option value={''} >{infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).languageCodeEdit.t034}</option>
           {selEmailType?.map((ob, i) =>{
            return <option key={i} value={ob} >{ob}</option>
           })}
           </select>
       </div>

}

const selectObArData =()=>{
    return <div className="code-edit-picker-field">
           <label>{__elakayText("t009", "data title for edit")}</label>
           <select onChange={handleTilteData()} >
           <option value={0} >{infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).languageCodeEdit.t035}</option>
           {!checkObjEmpty(languageTradictor) && languageTradictor[nameObj]?.map((ob, j) =>{
                return <option key={j} value={j} >{ob.data.title}</option>
               })}
           </select>
       </div>

}


const checkTitleIsOk = (array, title)=>{
  let newParagra = array.find(objt => objt.data.title === title)
  let Confirmation = array.some(item => item.data.title === title);

  if (!Confirmation) { 
    setJsonInput(defExempleJSOM)
    setHtmlTemplate(defExmpleHTML_CSS)
    setTilte(title)
    setParagra(ObjetPage)
    setEditAdd(true)
    // return true;
  } else { 
    setJsonInput(JSON.stringify(newParagra.data,  null, 2))
    setHtmlTemplate(newParagra.htmlTemplate)
    setTilte(newParagra.data.title)
     setParagra(newParagra)
    setEditAdd(false)
    // return false; 
  }
}

const loadErrorMessage = ()=>{
  return <div className="code-edit-error">
    <FaExclamationTriangle />
    <span>{errorMessage}</span>
  </div>
}

const btnAddEdit =()=>{
    // Bug fix : ce switch n'avait pas d'onChange (React loggait un warning
    // "checked prop without onChange") et ne reflétait pas vraiment un
    // contrôle utilisateur — editAdd est piloté ailleurs (checkTitleIsOk).
    // On le remplace par un badge de statut, plus honnête sur son rôle.
    return (
        <span className={`code-edit-mode-badge ${editAdd ? 'is-add' : 'is-edit'}`}>
            {infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).languageCodeEdit.t036}:{" "}
            {editAdd
                ? elakayAutoText("h_4641a8430a101d", "Creating new template")
                : elakayAutoText("h_1026589d94a432", "Editing existing template")}
        </span>
    );
}

  return (
    <div className="code-edit-page">
      <div className="code-edit-header">
        <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', flexWrap: 'wrap', gap: 12 }}>
          <div>
            <h1 className="code-edit-title">{infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).languageCodeEdit.t037}</h1>
            <p className="code-edit-subtitle">
              {infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).languageCodeEdit.t038}{" "}
              {infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).languageCodeEdit.t039}
            </p>
            {btnAddEdit()}
          </div>
          {paragra._id !== undefined && (
            <button onClick={() => setDeletePara(true)} className="code-edit-btn code-edit-btn-danger">
              <FaTrashAlt />{infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).languageCodeEdit.t040}
            </button>
          )}
        </div>
      </div>

      <div className="code-edit-picker">
        {selectObAr()}
      </div>

      {errorMessage && loadErrorMessage()}

      <div className="code-edit-panels">
        <div className="code-edit-panel">
          <div className="code-edit-panel-header">
            <span className="code-edit-panel-title"><FaCode />{infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).languageCodeEdit.t041}</span>
            <button className="code-edit-example-toggle" onClick={() => getExemple('JSON')}>
              {checkButton('JSON')
                ? <><FaEye />{infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).languageCodeEdit.t021}</>
                : <><FaEyeSlash />{infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).languageCodeEdit.t022}</>}
            </button>
          </div>
          <textarea
            className="code-edit-textarea"
            value={jsonInput}
            onChange={(e) => { setJsonInput(e.target.value); setErrorMessage(null) }}
            placeholder={infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).languageCodeEdit.t042}
          />
        </div>

        <div className="code-edit-panel">
          <div className="code-edit-panel-header">
            <span className="code-edit-panel-title"><FaFileCode />{infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).languageCodeEdit.t043}</span>
            <button className="code-edit-example-toggle" onClick={() => getExemple('HTML')}>
              {checkButton('HTML')
                ? <><FaEye />{infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).languageCodeEdit.t023}</>
                : <><FaEyeSlash />{infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).languageCodeEdit.t024}</>}
            </button>
          </div>
          <textarea
            className="code-edit-textarea"
            value={htmlTemplate}
            onChange={(e) => { setHtmlTemplate(e.target.value); setErrorMessage(null) }}
            placeholder={infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).languageCodeEdit.t044}
          />
        </div>
      </div>

      {btnActiveExmple()}
      {showEmailPage && printListeShop()}
      {deleteAgree()}
    </div>
  );
}

export default CodeEdit;
